import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewBannerComponent } from './preview-banner.component';



@NgModule({
    declarations: [
        PreviewBannerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        PreviewBannerComponent
    ]
})
export class PreviewBannerModule { }
